export default __webpack_public_path__ + "static/7-ip-bfe15438016cc6ba7eb876b4a4d449d9.png";